import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from '../components/ui/sonner';
import { Logo } from '../components/Logo';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { LOGIN } from '../constants/testIds';
import { getErrorMessage } from '../lib/errors';
import { setClientToken } from '../lib/authTokens';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ClientLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await axios.post(`${API}/client/login`, { email, password }, { withCredentials: true });
      if (data.access_token) setClientToken(data.access_token);
      navigate('/account');
    } catch (err) {
      toast.error(getErrorMessage(err, 'Invalid email or password'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-bg text-brand-text flex items-center justify-center px-5">
      <div className="text-center max-w-sm w-full">
        <div className="flex justify-center mb-8">
          <Logo />
        </div>
        <h1 className="font-display font-extrabold uppercase text-2xl text-brand-text">Client Login</h1>
        <p className="mt-2 text-brand-muted text-sm">Sign in to track your bulk order requests.</p>

        <form onSubmit={handleSubmit} className="mt-8 space-y-4 text-left">
          <div>
            <Label className="text-brand-muted text-xs uppercase tracking-wider">Email</Label>
            <Input
              type="email"
              required
              data-testid={LOGIN.emailInput}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 bg-brand-surface2 border-brand-border text-brand-text"
            />
          </div>
          <div>
            <Label className="text-brand-muted text-xs uppercase tracking-wider">Password</Label>
            <Input
              type="password"
              required
              data-testid={LOGIN.passwordInput}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 bg-brand-surface2 border-brand-border text-brand-text"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            data-testid={LOGIN.submitButton}
            className="w-full inline-flex items-center justify-center gap-2 bg-brand-orange hover:bg-brand-orangeHover text-white font-display font-bold uppercase tracking-wide rounded-full px-7 py-3 transition-colors disabled:opacity-60"
          >
            {submitting ? 'Signing in…' : 'Log In'}
          </button>
        </form>
        <p className="mt-4 text-brand-muted text-xs">
          <Link data-testid={LOGIN.forgotPasswordLink} to="/forgot-password" className="text-brand-amber underline">
            Forgot your password?
          </Link>
        </p>
        <p className="mt-6 text-brand-muted text-xs">
          New here?{' '}
          <Link data-testid={LOGIN.registerLink} to="/#order-form" className="text-brand-amber underline">
            Get a quote to create an account
          </Link>
        </p>
      </div>
    </div>
  );
}
